import React from "react";
import { Table } from "antd";

interface DataType {
    id: number;
    receiveDate: string;
    customerDate: string;
    stt: number;
    name: string;
    phone: string;
    dataType: string;
    source: string;
    telesale: string;
    serviceGroup: string;
    visits: number;
    customerType: string;
    branch: string;
    status: string;
    revenue: number;
}

const data: DataType[] = [
    {
        id: 1,
        receiveDate: "28/02/26",
        customerDate: "01/03/26",
        stt: 1,
        name: "Bảo Trân",
        phone: "938919997",
        dataType: "Mới",
        source: "Fb",
        telesale: "Thanh Hiền",
        serviceGroup: "1.New Hairs",
        visits: 1,
        customerType: "Khách mới",
        branch: "Q1",
        status: "Cọc trực tiếp",
        revenue: 6000000,
    },
    {
        id: 2,
        receiveDate: "13/09/25",
        customerDate: "01/03/26",
        stt: 2,
        name: "Lâu Đế Sa Huỳnh",
        phone: "368433767",
        dataType: "Để lại số",
        source: "Fb",
        telesale: "Thanh Hiền",
        serviceGroup: "1.New Hairs",
        visits: 1,
        customerType: "Khách mới",
        branch: "Q2",
        status: "Rớt",
        revenue: 0,
    },
    {
        id: 3,
        receiveDate: "24/02/26",
        customerDate: "01/03/26",
        stt: 3,
        name: "Lê Hoàng Dũng",
        phone: "919458459",
        dataType: "Mới",
        source: "Fb",
        telesale: "Quang",
        serviceGroup: "1.New Hairs",
        visits: 1,
        customerType: "Khách mới",
        branch: "Q1",
        status: "Thanh toán hết",
        revenue: 58080000,
    },
    {
        id: 4,
        receiveDate: "24/02/26",
        customerDate: "01/03/26",
        stt: 4,
        name: "Nguyễn Quốc Cường",
        phone: "939009456",
        dataType: "Upsale",
        source: "Fb",
        telesale: "Quang",
        serviceGroup: "Sản phẩm tóc",
        visits: 1,
        customerType: "Khách cũ",
        branch: "Q1",
        status: "Thanh toán hết",
        revenue: 4616000,
    },
    {
        id: 5,
        receiveDate: "27/11/25",
        customerDate: "01/03/26",
        stt: 5,
        name: "Thanh Trúc",
        phone: "8047792636",
        dataType: "Mới",
        source: "Fb",
        telesale: "Quang",
        serviceGroup: "1.New Hairs",
        visits: 1,
        customerType: "Khách đến thanh toán",
        branch: "Q1",
        status: "Thanh toán cọc",
        revenue: 74546000,
    },
    {
        id: 6,
        receiveDate: "26/02/26",
        customerDate: "01/03/26",
        stt: 6,
        name: "Lê Đức Việt",
        phone: "901290168",
        dataType: "Mới",
        source: "Fb",
        telesale: "Quang",
        serviceGroup: "1.New Hairs",
        visits: 1,
        customerType: "Khách mới",
        branch: "Q1",
        status: "Cọc trực tiếp",
        revenue: 5000000,
    },
    {
        id: 7,
        receiveDate: "11/01/26",
        customerDate: "01/03/26",
        stt: 7,
        name: "Lê Hoàng Chính",
        phone: "938691616",
        dataType: "Mới",
        source: "Fb",
        telesale: "Quang",
        serviceGroup: "1.New Hairs",
        visits: 1,
        customerType: "Khách mới",
        branch: "Q2",
        status: "Cọc online",
        revenue: 5000000,
    },
    {
        id: 8,
        receiveDate: "26/02/26",
        customerDate: "01/03/26",
        stt: 8,
        name: "Tạ Xuân Quy",
        phone: "947174889",
        dataType: "Mới",
        source: "Fb",
        telesale: "Ninh Giang",
        serviceGroup: "1.New Hairs",
        visits: 1,
        customerType: "Khách mới",
        branch: "Q2",
        status: "Rớt",
        revenue: 0,
    },
];

const formatMoney = (value: number) =>
    value.toLocaleString("vi-VN");

export default function CRMTable() {
    const columns = [
        { title: "STT", dataIndex: "stt" },
        { title: "Ngày nhận Data", dataIndex: "receiveDate" },
        { title: "Ngày khách đến", dataIndex: "customerDate" },
        { title: "Tên khách hàng", dataIndex: "name" },

        {
            title: "SĐT",
            render: (_: any, record: DataType) => (
                <div className="font-medium">
                    {record.phone}
                </div>
            ),
        },

        { title: "DATA", dataIndex: "dataType" },
        { title: "Nguồn", dataIndex: "source" },
        { title: "NV Telesale", dataIndex: "telesale" },
        { title: "Nhóm dịch vụ", dataIndex: "serviceGroup" },
        { title: "Lượt khách", dataIndex: "visits" },
        { title: "Phân loại khách", dataIndex: "customerType" },
        { title: "Cơ sở", dataIndex: "branch" },
        { title: "Tình trạng", dataIndex: "status" },

        {
            title: "Doanh thu",
            render: (_: any, record: DataType) => (
                <div className="text-right font-semibold">
                    {formatMoney(record.revenue)}
                </div>
            ),
        },
    ];

    return (
        <div className="bg-white rounded-lg shadow">
            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                pagination={false}
                scroll={{ x: "max-content" }}
                className="custom-ant-table"
            />
        </div>
    );
}